import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { StorageService } from '../../_services/storage.service';
@Injectable({
    providedIn: 'root'
  })
  export class TfaGuard implements CanActivate {
    constructor(private router: Router, private storageService: StorageService) {}
  
    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
      // Skip TFA check for auth routes
      if (state.url.includes('/auth/')) {
        return true;
      }
  
      const tfaUsername = localStorage.getItem('tfaUsername');
      const tfaToken = localStorage.getItem('tfaToken');
      const authToken = this.storageService.getToken();
      

       // Handle TFA setup route
    // if (state.url.includes('/auth/tfa-setup')) {
    //   // Only allow access if:
    //   // 1. User has auth token (logged in)
    //   // 2. TFA is enabled but QR not granted
    //   // 3. Has tfaUsername marker
    //   if (authToken && tfaUsername && tfaToken === 'pending-setup') {
    //     return true;
    //   }
    //   this.router.navigate(['/auth/login']);
    //   return false;
    // }
 
    if (tfaUsername && tfaToken === 'pending-setup' && authToken) {
      if (!state.url.includes('/auth/tfa-setupy')) {
        this.router.navigate(['/auth/tfa-setup']);
        return false;
      }
      return true;
    }
      // Case 1: User has completed auth but not TFA
      if (tfaUsername && tfaToken === 'pending-verification' && authToken) {
        if (!state.url.includes('/auth/tfa-verify')) {
          this.router.navigate(['/auth/tfa-verify']);
          return false;
        }
        return true;
      }
       // Handle TFA setup route
    if (state.url.includes('/auth/tfa-setup')) {
        // Only allow access if:
        // 1. User has auth token (logged in)
        // 2. TFA is enabled but QR not granted
        // 3. Has tfaUsername marker
        if (authToken && tfaUsername && tfaToken === 'pending-setup') {
          return true;
        }
        this.router.navigate(['/auth/login']);
        return false;
      }
  
  
      // Case 2: User has TFA markers but no auth token (invalid state)
      if ((tfaUsername || tfaToken) && !authToken) {
        console.warn('Clearing invalid TFA state - missing auth token');
        localStorage.removeItem('tfaUsername');
        localStorage.removeItem('tfaToken');
        this.router.navigate(['/auth/login']);
        return false;
      }
  
      // Case 3: Normal access - either no TFA required or already completed
      return true;
    }
  }